export default __webpack_public_path__ + "static/media/featureImage4.f5b63572.png";